export const handleButtonClickedEvent = (eventName, eventData = {}) => {
  if (window.fbq) {
    window.fbq(
      "track",
      `${eventName}${eventData.agent ? ` - ${eventData.agent}` : ""}`,
      eventData
    );
  }

  if (window.gtag) {
    window.gtag("event", eventName, eventData);
  }
};

export const handleFormSubmissionEvent = (formData = {}, eventData = {}) => {
  const nameParts = formData.name?.trim().split(/\s+/) ?? ["", ""];
  const firstName = nameParts[0];
  const lastName = nameParts.length > 0 ? nameParts.slice(1).join(" ") : "";

  if (window.fbq) {
    window.fbq("init", "1385122506271325", {
      em: formData.email,
      fn: firstName,
      ln: lastName,
      ph: formData.phone,
    });
    window.fbq(
      "track",
      `GetPropertyReportSubmission${
        eventData.agent ? ` - ${eventData.agent}` : ""
      }`,
      eventData
    );
  }

  if (window.gtag) {
    window.gtag("event", "conversion_event_submit_lead_form_1", eventData);
  }
};

// form_type: formData.subject ? "page" : "popup",
